module.exports = __webpack_public_path__ + "img/Earth.5dd72aed.png";